import { defineMessages } from "react-intl";

export const contactUsFormMessages = defineMessages({
  filterPresetsAll: {
    defaultMessage: "All Contact Us Form orders",
    id: "COAovO",
  },
});
